import React from 'react';
import './Footer.css';

export default function Footer() {
  return (
    <footer className="footer">
      <p className="footer__tagline">
        Built by procurement people.{' '}
        <span className="footer__tagline-accent">Amplified by AI.</span>
      </p>
    </footer>
  );
}
